<template>
    <vx-expandable-card>
        <template v-slot:header> Update Password </template>

        <template v-slot:content>
            <div class="flex flex-col gap-6 mt-3">
                <vx-alert v-if="success" :closeable="false" color="success" shadow> Updated successfully </vx-alert>
                <div>
                    <vx-label size="md"> Current Password </vx-label>

                    <vx-input
                        type="password"
                        togglePassword
                        size="lg"
                        name="current_password"
                        v-model="form.current_password"
                        :error="displayFirstError(validate.current_password)"
                        data-test="current_password"
                    ></vx-input>
                </div>

                <div>
                    <vx-label size="md"> Password </vx-label>

                    <vx-input
                        type="password"
                        togglePassword
                        size="lg"
                        name="password"
                        v-model="form.password"
                        :error="displayFirstError(validate.password)"
                        data-test="password"
                    ></vx-input>
                </div>

                <div>
                    <vx-label size="md"> Password Confirmation </vx-label>

                    <vx-input
                        type="password"
                        togglePassword
                        size="lg"
                        name="password_confirmation"
                        v-model="form.password_confirmation"
                        :error="displayFirstError(validate.password_confirmation)"
                        data-test="password_confirmation"
                    ></vx-input>
                </div>

                <vx-button block size="lg" @click="update" data-test="submit" :loading="submitting"> Update </vx-button>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxButton, VxExpandableCard, VxLabel, VxInput, VxAlert } from '@voxie/frontend-components';
import axios from '~/services/axios';
import { reactive, ref, computed } from 'vue';
import { useFormRequestHandler } from '~/composables/useFormRequestHandler';
import useVuelidate from '@vuelidate/core';
import { required, minLength, sameAs, helpers } from '@vuelidate/validators';
import { displayFirstError, validateRules } from '~/utils/validation';

const submitting = ref(false);
const success = ref(false);

const form = reactive({
    current_password: '',
    password: '',
    password_confirmation: '',
});

const rules = {
    current_password: { required },
    password: { required, minLength: minLength(12) },
    password_confirmation: {
        required,
        sameAs: helpers.withMessage(
            'Passwords must match.',
            sameAs(
                computed(() => form.password),
                'password'
            )
        ),
    },
};

const { $externalResults, catchError } = useFormRequestHandler();

const validate = useVuelidate(rules, form, {
    $externalResults,
});

const update = async () => {
    if (submitting.value) {
        return;
    }

    submitting.value = true;
    success.value = false;

    if (!(await validateRules(validate))) {
        submitting.value = false;
        return;
    }

    axios
        .put('/settings/password', {
            ...form,
        })
        .then(async () => {
            form.current_password = '';
            form.password = '';
            form.password_confirmation = '';

            success.value = true;
            validate.value.$reset();
        })
        .catch((err) => {
            catchError(err);
        })
        .finally(() => (submitting.value = false));
};
</script>
